import { render, staticRenderFns } from "./RemissionColumns.vue?vue&type=template&id=221de67a&scoped=true"
import script from "./RemissionColumns.vue?vue&type=script&lang=js"
export * from "./RemissionColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221de67a",
  null
  
)

export default component.exports